import React from 'react';

export function AvatarBoy(props) {
    return (
        <svg viewBox="0 0 100 92" {...props}>
            <path
                fillRule="evenodd"
                d="M3.826 84.54c10.449-7.217 38.775-10.811 34.06-18.548-3.202-1.643-6.73-7.183-8.308-10.211-.762-1.508-1.4-3.05-3.847-2.54-3.713.227-9.192-10.356-6.057-13.778.23-.25 1.071-.666 1.348-.905 1.453-1.25.92-1.67.439-4.527-1.762-10.46 2.135-21.262 12.638-28.127 2.529-1.474 4.912-2.753 8.477-3.85C47.186.637 54.986-.963 59.433.727c1.886.716 3.549 1.621 4 2.964.448 1.328-.917 2.945-.051 3.419 1.554 1.096 4.842-3.635 9.714 2.029 5.46 6.346 6.46 15.871 4.963 24.303-.33 1.86-1.756 3.505.117 5.116.277.24 1.118.655 1.348.905 3.135 3.422-2.344 14.005-6.056 13.778-2.447-.51-3.086 1.032-3.849 2.54-1.578 3.028-5.106 8.568-8.309 10.211-4.713 7.737 23.613 11.33 34.061 18.549 2.245 1.549 3.716 4.765 3.826 6.818H0c.11-2.053 1.582-5.27 3.826-6.818z"
            />
        </svg>
    );
}
